import {bymoTemplateDataCreateForMetadata} from '../../../doppe-sdk';
import {BymoTemplateSpeedDialTemplateMetadata} from './bymo-template-speed-dial.metadata';
import React from 'react';
import {BymoTemplateSpeedDialInner} from './bymo-template-speed-dial';
import {
    DoppeLayoutDefaultProfileViewSkin,
    DoppeLayoutDefaultProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout-default-profile-view-template/doppe-layout-default-profile-view-template';
import {
    DoppeLayout5ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout5-profile-view-template/doppe-layout5-profile-view-template';
import {
    BymoTemplateLayout,
    bymoTemplateLayoutIsStandardDesktopBackground,
    bymoTemplateLayoutSupportsDesktopBackground
} from '../../../client-server-common';
import {
    DoppeLayout6ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout6-profile-view-template/doppe-layout6-profile-view-template';
import {
    DoppeLayout1ProfileViewSkin,
    DoppeLayout1ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout1-profile-view-template/doppe-layout1-profile-view-template';
import {
    DoppeLayout7ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout7-profile-view-template/doppe-layout7-profile-view-template';
import {
    DoppeLayout8ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout8-profile-view-template/doppe-layout8-profile-view-template';
import {
    DoppeLayout9ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout9-profile-view-template/doppe-layout9-profile-view-template';
import {
    DoppeLayout10ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout10-profile-view-template/doppe-layout10-profile-view-template';
import {
    DoppeLayout11ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout11-profile-view-template/doppe-layout11-profile-view-template';
import {
    DoppeLayout12ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout12-profile-view-template/doppe-layout12-profile-view-template';
import {
    DoppeLayout13ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout13-profile-view-template/doppe-layout13-profile-view-template';
import {
    DoppeLayout14ProfileViewTemplate
} from '../../doppe-profile-view-templates/doppe-layout14-profile-view-template/doppe-layout14-profile-view-template';
import {evaluateFunction} from "@wix/devzai-utils-common";
import {
    DoppePageDesktopBackgroundView
} from "../../doppe-page-desktop-background-view/doppe-page-desktop-background-view";

export const BymoTemplateSpeedDialTemplateData = bymoTemplateDataCreateForMetadata(
    BymoTemplateSpeedDialTemplateMetadata,
    React.memo(function BymoTemplateSpeedDial(props) {
        const {
            pageLayout,
            desktopLayout
        } = props;


        return (
            <>
                {bymoTemplateLayoutSupportsDesktopBackground(pageLayout.layout) && bymoTemplateLayoutIsStandardDesktopBackground(desktopLayout.layout) ?
                    <DoppePageDesktopBackgroundView/> :
                    null
                }
                {evaluateFunction(() => {
                    switch (pageLayout.layout) {
                        case BymoTemplateLayout.Standard: {
                            return <BymoTemplateSpeedDialInner
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Blank: {
                            return <DoppeLayoutDefaultProfileViewTemplate
                                {...props}
                                skin={DoppeLayoutDefaultProfileViewSkin.Blank}
                            />
                        }
                        case BymoTemplateLayout.Layout1: {
                            return <DoppeLayoutDefaultProfileViewTemplate
                                skin={DoppeLayoutDefaultProfileViewSkin.Standard}
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout2: {
                            return <DoppeLayout1ProfileViewTemplate
                                skin={DoppeLayout1ProfileViewSkin.WithGradient}
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout3: {
                            return <DoppeLayoutDefaultProfileViewTemplate
                                {...props}
                                skin={DoppeLayoutDefaultProfileViewSkin.BigProfile}
                            />
                        }
                        case BymoTemplateLayout.Layout4: {
                            return <DoppeLayout1ProfileViewTemplate
                                skin={DoppeLayout1ProfileViewSkin.Standard}
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout5: {
                            return <DoppeLayout5ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout6: {
                            return <DoppeLayout6ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout7: {
                            return <DoppeLayout7ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout8: {
                            return <DoppeLayout8ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout9: {
                            return <DoppeLayout9ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout10: {
                            return <DoppeLayout10ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout11: {
                            return <DoppeLayout11ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout12: {
                            return <DoppeLayout12ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout13: {
                            return <DoppeLayout13ProfileViewTemplate
                                {...props}
                            />
                        }
                        case BymoTemplateLayout.Layout14: {
                            return <DoppeLayout14ProfileViewTemplate
                                {...props}
                            />
                        }
                        default : {
                            return <BymoTemplateSpeedDialInner
                                {...props}
                            />
                        }
                    }
                })}
            </>
        )
    })
)